module.exports = btmShared.sessionUtil;